import React from 'react';
import { painPoints } from '../data/painPoints';
import { PRODUCT } from '../data/constants';
export function PainSection() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-146" data-mp="38xetra38ohqd">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-147" data-mp="2uyfdappvr95a">
        <h2 className="text-center text-2xl leading-tight text-white sm:text-4xl" data-id="element-148" data-mp="2uxvwxdfvostd">
          ET SI CHAQUE ECG <span className="text-tech-light" data-id="element-149" data-mp="2yxxouuvta7vg">SE LISAIT AVEC MÉTHODE ?</span>
        </h2>
        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-white/85 sm:text-base" data-id="element-150" data-mp="2l6riceu479z2">
          Vous connaissez déjà les ondes P, QRS et T. Le vrai défi, c’est de savoir{' '}
          <strong className="text-white" data-id="element-151" data-mp="2bbr6pfsobbri">
            quoi regarder en premier, dans quel ordre, et quand transmettre ou alerter
          </strong>{' '}
          devant un tracé ou un scope. Au lieu de chercher dans des supports dispersés,{' '}
          {PRODUCT} vous donne un parcours visuel clair, des fondamentaux aux cas pédagogiques.
        </p>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-152" data-mp="3rmr41xb0cn1h">
          {painPoints.map(point => <article key={point.title} className="rounded-xl border-l-4 border-alert bg-navy-deep p-3 sm:p-4" data-id="element-153" data-mp="3nlysuyiks82k">
              <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-154" data-mp="5dq5oiiedufx">{point.title}</h3>
              <p className="mt-1 text-sm leading-snug text-white/80" data-id="element-155" data-mp="hivgdiyxws6">{point.body}</p>
            </article>)}
        </div>

        <p className="mt-3 text-center font-display text-sm font-extrabold uppercase text-tech-light sm:text-lg" data-id="element-156" data-mp="33xg6eooyf8rk">
          Lire. Mesurer. Comparer. Alerter.
        </p>
      </div>
    </section>;
}